import React from "react";
import DialogIcon from "./DialogIcon";
import ConfirmButton from "./ConfirmButton";
import "./Dialog.css";

class Dialog extends React.Component {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleKeyDown = (event) => {
    const ESCAPE_KEY = 27;
    if (event.keyCode === ESCAPE_KEY && this.props.onHideDialog) {
      this.props.onHideDialog();
    }
  };

  render() {
    const position = {
      top: this.props.dialog.topPosition,
      left: this.props.dialog.leftPosition
    };

    const isMobile = window.innerWidth <= 768;
    const messageStyle = isMobile
      ? {
          whiteSpace: "normal",
          wordWrap: "break-word",
          maxWidth: "100%"
        }
      : {};

    return (
      <div
        className={`dialog dialog--${this.props.dialog.origin}`}
        style={position}
      >
        <div
          className={`dialog__content${
            this.props.dialog.type ? "--" + this.props.dialog.type : ""
          }`}
        >
          <h3 className="dialog__title">{this.props.dialog.title}</h3>
          <p className="dialog__message" style={messageStyle}>
            {this.props.dialog.message}
          </p>
        </div>

        {this.props.onHideDialog && (
          <ConfirmButton
            onHandleConfirm={this.props.onHideDialog}
            type={this.props.dialog.type}
          />
        )}

        <DialogIcon
          origin={this.props.dialog.origin}
          type={this.props.dialog.type}
        />
      </div>
    );
  }
}

export default Dialog;
